<template>
  <!-- 诚信评价-扣分详情 -->
  <div class="deduct_detail">
    <div class="head">
      <div class="head_left">
        <div class="head_title">{{ integrityTypeCN }}</div>
        <!-- <div class="tags"> -->
        <!-- <span>{{ detailInfo.areaName }}</span> -->
        <!-- <span>{{ detailInfo.areaType == 1 ? "一" : "二" }}类地区</span> -->
        <!-- </div> -->
        <div class="time">{{ areaName }} {{ quarterName }}</div>
      </div>
      <div class="head_right">
        <div class="deduct_score" v-if="$route.query.audited == 1">-{{ ($route.query.deduction / 100).toFixed(2) }}</div>
        <!-- <div class="percent" v-if="detailInfo.audited == 1">{{`${(detailInfo.score / 100).toFixed(2)}/${(detailInfo.sumScore / 100).toFixed(2)}`}}</div> -->
        <div class="status" v-else>未扣分</div>
      </div>
    </div>
    <div class="content">
      <div class="happend_time" v-if="detailInfo.audited == 1">
        <div class="tit">扣分原因</div>
        <div class="desc" v-if="integrityType == 'C2' && detailInfo.unfinishNum > 0 ">未完成业态数量：{{ detailInfo.unfinishNum }}</div>
        <div v-else  class="desc more_desc" ref="showMore" id="showMore" :class="{ show_more: showMore }" >{{
          detailInfo.deductionReason }}</div>
        <div class="open_more" v-show="oprate_dom">
          <span v-show="showMore" @click="openMore">展开</span>
          <span v-show="!showMore" @click="openMore">收起</span>
          <i v-show="showMore" class="drop_down"></i>
          <i v-show="!showMore" class="drop_up"></i>
        </div>
      </div>
      <!-- <div class="related_file">
        <div class="file_title">相关材料</div>
        <div class="file_item" v-for="(item, index) in detailInfo.fileResVOS" :key="index">
          <div class="file_msg" @click="openFile(item)">
            <img src="@/assets/appraise/ic_pdf.png" alt />
            <p>
              <span>{{ `${item.fileName}.${item.fileType}` }}</span>
            </p>
          </div>
          <div class="file_size">{{ item.fileSize }}</div>
        </div>
      </div>-->
      <div class="upload_file">
        <div class="upload_tit">相关材料</div>
        <div class="file_item" v-for="(item, index) in detailInfo.fileResVOS" :key="index">
          <div class="file_msg">
            <img src="@/assets/appraise/ic_pdf.png" alt />
            <p class="file_name" style="align-self: center">
              <span>{{ item.fileName }}.{{ item.fileType }}</span>
            </p>
          </div>
          <!-- <div class="delImg" @click="del(index)">
            <img src="@/assets/appraise/delete.png" alt />
          </div>-->
          <div class="file_size">{{ item.fileSize }}</div>
        </div>
      </div>
    </div>

    <!-- <div class="bot_btn">
        <div class="opreate">
          <div class="delete_btn" @click="deleteSituation" v-if="deleteAuth === 'OPERATION03'">
            <img src="@/assets/appraise/delete.png" alt />
            <span class>删除</span>
          </div>
          <div class="edit_btn" @click="editSituation" v-if="updateAuth === 'OPERATION02'">
            <img src="@/assets/appraise/Group 2@2x.png" alt />
            <span>编辑</span>
          </div>
        </div>
        <div class="check_btn" v-if="userAuthoirese === 'OPERATION06'">
          <van-button @click="check" type="primary">审核</van-button>
        </div>
    </div>-->

    <!-- <div class="bot_btn" v-if="detailInfo.audited == 0">
      <btnauth custype="apply" :year="year" :quarter="quarter">
        <div class="opreate">
          <div class="delete_btn" @click="deleteSituation" v-if="deleteAuth === 'OPERATION03'">
            <img src="@/assets/appraise/delete.png" alt />
            <span class>删除</span>
          </div>
          <div class="edit_btn" @click="editSituation" v-if="updateAuth === 'OPERATION02'">
            <img src="@/assets/appraise/Group 2@2x.png" alt />
            <span>编辑</span>
          </div>
        </div>
      </btnauth>
      <btnauth custype="audit" :year="year" :quarter="quarter">
        <div class="check_btn" v-if="userAuthoirese === 'OPERATION06'">
          <van-button @click="check" type="primary">审核</van-button>
        </div>
      </btnauth>
    </div> -->
    <!-- <van-button @click="check" type="primary">审核</van-button> -->
    <!-- <confirmDialog
      v-if="showDialog"
      :title="dialogTitle"
      :content="dialogContent"
      :cancelTxt="cancelBtn"
      :confirmTxt="confirmBtn"
      @confirm="confirm"
      @cancel="cancel"
    ></confirmDialog>
    <modalIframe :url="iframeurl"></modalIframe> -->
  </div>
</template>

<script>
import API from "@/service/modules/appraiseNewWzy.js";
import confirmDialog from "../components/confirmDialog.vue";
import btnauth from "../appraiseNew/components/btnauth";
import modalIframe from "../appraiseNew/components/modalIframe";
import commonAPI from "@/utils/common";
export default {
  components: {
    confirmDialog,
    btnauth,
    modalIframe,
  },
  data() {
    return {
      detailInfo: {}, // 详情信息
      showDialog: false,
      showMore: true,
      oprate_dom: this.$route.query.integrityType != 'C2',
      dialogTitle: "",
      dialogContent: "",
      cancelBtn: "",
      confirmBtn: "",
      detailQuery: {}, // 参数
      id: "", // 信息id
      year: this.$route.query.year,
      quarter: this.$route.query.quarter,
      // updateAuth: this.$route.query.updateAuth,
      // deleteAuth: this.$route.query.deleteAuth,
      // userAuthoirese: this.$route.query.userAuthoirese,
      iframeurl: "",
      quarterName:this.$route.query.quarterName,
      area: this.$route.query.area,
      areaName:this.$route.query.areaName,
      integrityType: this.$route.query.integrityType,
      integrityTypeCN: this.$route.query.integrityTypeCN,
    };
  },
  created() {
    /** 获取参数 **/
    this.detailQuery = this.$route.query;
    // const params = commonAPI.getJsonLocal("creditlistparams");
    // console.log("存的参数:", params);
    // if (params) {
    //   this.detailQuery = params;
    // }
    this.detailQuery = {
      area: this.$route.query.area,
      integrityType: this.$route.query.integrityType,
      quarter: this.$route.query.quarter,
      year: this.$route.query.year
    }
    this.getDetails();
  },
  updated() {
    this.$nextTick(() => {
      if (
        this.detailInfo.deductionReason &&
        this.detailInfo.deductionReason.length < 120
      ) {
        this.oprate_dom = false;
      }
    });
  },
  methods: {
    openMore(type) {
      type = typeof type == "object" ? "" : type;
      this[`showMore${type}`] = !this[`showMore${type}`];
    },
    /**
     * @description: 获取详情信息
     */
    async getDetails() {
      const res = await API.getIntegrityDetails(this.detailQuery);
      console.log("返回的详情:", res);
      if (res.ret === 0) {
        this.detailInfo = res.data ? res.data : {};
        this.id = res.data ? res.data.id : "";
      }
    },
    /**
     * @description: 打开附件
     * @param { item } object
     */
    openFile(item) {
      const _this = this;
      const str = navigator.userAgent.toLowerCase();
      const ver = str.match(/cpu iphone os (.*?) like mac os/);
      if (!ver) {
        console.log("---安卓进来这里url:", item.fileUrl);
        // this.$toast('当前暂不支持预览附件')
        // console.log('不是苹果')
        this.iframeurl = item.fileUrl;
        // this.$router.push({
        //   path: "/appraise/iframepdf",
        //   query: { url: item.fileUrl },
        // });
      } else {
        window.yyn.invokeJSB(
          "openWindow",
          {
            openUrl: item.fileUrl,
            isFullScreen: 0,
            setTitle: name,
            needLoading: 1,
          },
          (cb) => {
            console.log(cb, "callback");
          }
        );
      }
      setTimeout(() => {
        _this.iframeurl = "";
      }, 100);
    },
    // 审核
    check() {
      this.$router.push({
        path: "/appraise/checkCredit",
        query: {
          id: this.id,
          integrityType: this.detailQuery.integrityType,
        },
      });
    },
    // 删除情况
    deleteSituation() {
      this.dialogTitle = "是否确定删除";
      this.dialogContent = "";
      this.cancelBtn = "取消";
      this.confirmBtn = "删除";
      this.showDialog = true;
    },
    // 编辑
    editSituation() {
      this.$router.push({
        path: "/appraise/addCredit",
        query: {
          area: this.detailQuery.area,
          year: this.detailQuery.year,
          quarter: this.detailQuery.quarter,
          integrityType: this.detailQuery.integrityType,
          updateAuth: this.updateAuth,
          deleteAuth: this.deleteAuth,
          userAuthoirese: this.userAuthoirese,
        },
      });
    },
    /**
     * @description: 删除二次确认回调
     */
    async confirm() {
      this.showDialog = false;
      const res = await API.delIntegrity({
        id: this.id,
        operateType: this.detailQuery.integrityType,
      });
      if (res.ret === 0) {
        // this.$router.replace({
        //   path: "/appraise/creditList",
        //   query: {
        //     area: this.detailQuery.area,
        //     year: this.detailQuery.year,
        //     quarter: this.detailQuery.quarter,
        //     assessName: "涉旅企业诚信评价进展情况",
        //   },
        // });
        this.$router.back(-1);
      }
    },
    // 弹窗失败回调
    cancel() {
      this.showDialog = false;
    },
  },
};
</script>

<style scoped lang="less">
.deduct_detail {
  .head {
    display: flex;
    justify-content: space-between;
    padding: 0 12px 12px 12px;
    width: 100%;
    border-bottom: 1px solid #eee;
  }

  .head_left {
    .head_title {
      margin: 24px 0 12px;
      color: #333;
      font-size: 20px;
      font-weight: bold;
    }

    .tags span {
      display: inline-block;
      margin-right: 9px;
      padding: 1px 4px;
      font-size: 10px;
      line-height: 14px;
      color: #36b374;
      border: 1px solid #36b374;
    }

    .time {
      margin-top: 12px;
      font-size: 12px;
      color: #999;
    }
  }

  .head_right {
    padding-top: 22px;

    .deduct_score {
      font-size: 22px;
      font-weight: 500;
      color: #ff4d4d;
    }

    .percent {
      margin: 8px 0 16px;
      color: #999;
      font-size: 14px;
      font-weight: 500;
    }

    .status {
      margin-left: 9px;
      font-size: 14px;
      color: #ff8c19;
    }
  }

  .content {
    margin-bottom: 60px;

    .deduct_reason,
    .happend_time {
      padding: 0 12px;
      border-bottom: 1px solid #eee;
      line-height: 22px;
      color: #333;

      .tit {
        padding: 15px 0 14px;
        font-size: 16px;
        font-weight: bold;
      }

      .desc {
        padding-bottom: 16px;
        font-size: 14px;
        font-weight: 400;
      }
    }
  }

  .upload_file {
    padding: 0 12px 16px;
    background-color: #fff;

    .upload_tit {
      padding: 16px 0;
      font-size: 14px;
      color: #666;
      font-weight: bold;
    }
  }

  // .related_file {
  //   padding: 0 12px;
  //   .file_title {
  //     padding: 15px 0 16px;
  //     font-size: 16px;
  //     font-weight: bold;
  //     color: #333;
  //   }
  .file_item {
    display: flex;
    box-sizing: border-box;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 15px;

    .file_msg {
      flex: 1;
      display: flex;
      align-items: center;
    }

    .file_msg img {
      margin-right: 12px;
      width: 34px;
      height: 38px;
    }

    .file_msg p {
      font-size: 14px;
      color: #333;

      span {
        line-height: 20px;
        word-break: break-word;
      }
    }

    .file_size {
      font-size: 12px;
      color: #999;
    }

    .delImg {
      box-sizing: border-box;
      line-height: 38px;
      margin-left: 5px;
      margin-right: 10px;
    }

    .delImg img {
      width: 15px;
      height: 16px;
    }
  }

  //   .file_item {
  //     display: flex;
  //     justify-content: space-between;
  //     padding-bottom: 15px;
  //     .file_msg {
  //       display: flex;
  //     }
  //     .file_msg img {
  //       margin-right: 12px;
  //       width: 34px;
  //       height: 38px;
  //     }
  //     .file_msg img {
  //       display: inline-block;
  //       margin-right: 12px;
  //       width: 34px;
  //       height: 38px;
  //       vertical-align: middle;
  //     }
  //     .file_msg p {
  //       display: inline-block;
  //       width: 232px;
  //       height: 38px;
  //       font-size: 14px;
  //       color: #333;
  //       span {
  //         line-height: 22px;
  //         word-break: break-word;
  //       }
  //     }
  //     .file_size {
  //       line-height: 38px;
  //       font-size: 12px;
  //       color: #999;
  //     }
  //   }
  // }
  .bot_btn {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    justify-content: space-between;
    padding: 10px 16px;
    height: 60px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px -2px 8px 0px rgba(0, 0, 0, 0.03);

    .opreate {
      padding: 12px 0;

      div {
        display: inline-block;
      }
    }

    .delete_btn {
      margin-right: 24px;
    }

    img {
      display: inline-block;
      margin-right: 4px;
      width: 16px;
      height: 16px;
      vertical-align: middle;
    }

    span {
      display: inline-block;
      font-size: 16px;
      color: #36b374;
      vertical-align: middle;
    }
  }

  .check_btn .van-button {
    width: 203px;
    height: 40px;
    border-radius: 3px;
    background-color: #36b374;

    span {
      color: #fff;
      font-size: 16px;
      font-weight: 400;
    }
  }
}

.more_desc {
  margin-bottom: 10px;
  padding-bottom: 0 !important;
  display: inline-block;
}

.show_more {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 5;
  overflow: hidden;
  text-emphasis: ellipsis;
}

.open_more {
  padding-bottom: 16px;
  text-align: center;

  span {
    margin-right: 5px;
    font-size: 14px;
    color: #666;
  }

  .drop_down {
    display: inline-block;
    width: 0;
    height: 0;
    border: 4px solid #9b9b9b;
    border-left-color: transparent;
    border-right-color: transparent;
    border-bottom-color: transparent;
  }

  .drop_up {
    display: inline-block;
    width: 0;
    height: 0;
    border: 4px solid #9b9b9b;
    border-left-color: transparent;
    border-right-color: transparent;
    border-top-color: transparent;
  }
}
</style>
